export default __webpack_public_path__ + "static/media/i-no-transfer.45ee9d62.svg";